import React, { Component } from "react";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import "./ContactDetailsAction.css";
import swal from "sweetalert";
import { fetchMethod } from "../../../FetchMethod";
import {
  campaignContactStatusMutation,
  campaignContactLogMaintain
} from "../../../Queries";
class ContactDetailsAction extends Component {
  state = {
    anchorEl: null,
    campaignStatus: [
      "Live Campaign",
      "Pause Campaign",
      "Remove Contact",
      "Convert Engaged"
    ],
    convertTo: ["Suspect", "Prospect", "Opportunity"]
  };

  convertToList = () => {
    let convertToMessage = [];
    let campaignstatus = [];

    let contactstatus =
      this.props.contactStatus !== null
        ? this.props.contactStatus.toLowerCase()
        : "";
    let campStatus =
      this.props.campaignStatus != null
        ? this.props.campaignStatus.toLowerCase()
        : "";

    switch (campStatus) {
      case "live":
        campaignstatus[0] = "Pause Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Convert Engaged";
        break;
      case "pause":
        campaignstatus[0] = "Live Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Convert Engaged";
        break;
      default:
        campaignstatus[0] = "Live Campaign";
        campaignstatus[1] = "Pause Campaign";
        campaignstatus[2] = "Remove Contact";
        campaignstatus[3] = "Convert Engaged";
    }

    switch (contactstatus) {
      case "suspect":
        convertToMessage[0] = "Prospect";
        convertToMessage[1] = "Opportunity";
        break;
      case "prospect":
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Opportunity";
        break;
      case "opportunity":
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Prospect";
        break;
      default:
        convertToMessage[0] = "Suspect";
        convertToMessage[1] = "Prospect";
        convertToMessage[2] = "Opportunity";
    }
    this.setState({ convertTo: convertToMessage });
    this.setState({ campaignStatus: campaignstatus });
  };

  convertToClickList = event => {
    this.setState({ anchorEl: event.currentTarget });
    event.stopPropagation();
    this.convertToList();
  };

  clickToConvertStatus = (newStatus, currentStatus) => {
    let status = currentStatus !== null ? currentStatus.toLowerCase() : "";
    switch (status) {
      case "suspect":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      case "prospect":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      case "opportunity":
        this.changeContactStatus(newStatus, status, this.props.id);
        break;
      default:
        this.changeContactStatus(newStatus, status, this.props.id);
    }
    this.convertToClose();
  };
  changeContactStatus = (newStatus, status, id) => {
    let updateStatus = {};
    if (newStatus !== "NOOP") {
      updateStatus = {
        where: { id: id },
        data: {
          contactstatus: newStatus,
          campaignstatus: "Pause",
          engaged: 0,
          leads: 1,
          noop: 0,
          updatedon: Date(Date.now()),
          updatedby: localStorage.getItem("id")
        }
      };
    } else {
      updateStatus = {
        where: { id: id },
        data: {
          contactstatus: newStatus,
          campaignstatus: "Pause",
          noop: 1,
          engaged: 0,
          leads: 0,
          updatedon: Date(Date.now()),
          updatedby: localStorage.getItem("id")
        }
      };
    }
    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(campaignContactStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully converted", { icon: "success" }).then(() => {
                this.props.tableRerender.searchFetch(
                  this.props.limit,
                  this.props.offset
                );
              });

              this.logMaintain(newStatus, id);
            } else swal("Error", { icon: "error" });
          })
          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };
  logMaintain = (newStatus, id) => {
    let newstatus = newStatus.toLowerCase();
    let updateLog = {};
    let createdBy = localStorage.getItem("id");
    switch (newstatus) {
      case "prospect":
        updateLog = {
          data: {
            contactid: id,
            action: "CONVERT_TO_PROSPECT",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "suspect":
        updateLog = {
          data: {
            contactid: id,
            action: "CONVERT_TO_SUSPECT",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "opportunity":
        updateLog = {
          data: {
            contactid: id,
            action: "CONVERT_TO_OPPORTUNITY",
            createdon: Date(Date.now()),
            createdby: createdBy
          }
        };
        break;
      case "noop":
        updateLog = {
          data: {
            contactid: id,
            action: "CONVERT_TO_NOOP",
            createdon: Date(Date.now()),
            createdby: createdBy,
            engaged: 0
          }
        };
        break;
      default: {
      }
    }
    if (newStatus === "Pause Campaign") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_PAUSED",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Live Campaign") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_LIVE",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Remove Contact") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_REMOVE",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    if (newStatus === "Convert Engaged") {
      updateLog = {
        data: {
          contactid: id,

          action: "CONVERT_TO_ENGAGED",
          createdon: Date(Date.now()),
          createdby: createdBy
        }
      };
    }
    fetchMethod(campaignContactLogMaintain, updateLog)
      .then(response => {
        return response.json();
      })
      .then(res => {})
      .catch(e => console.log(e));
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  onClickToConvertCampaignStatus = (newStatus, currentStatus) => {
   // let status = currentStatus !== null ? currentStatus.toLowerCase() : "";
    this.changeCampaignStatus(newStatus, this.props.id);
    this.convertToClose();
  };

  changeCampaignStatus = (newStatus, id) => {
    let newstatus = newStatus !== null ? newStatus.toLowerCase() : "";
    let updatedBy = localStorage.getItem("id");
    let updateStatus = {};

    if (newstatus === "live campaign") {
      updateStatus = {
        where: { id: id },
        data: {
          campaignstatus: "Live",
          updatedon: Date(Date.now()),
          updatedby: updatedBy,
          engaged: 0,
          leads: 0,
          noop: 0,
          contactstatus: null
        }
      };
    }
    if (newstatus === "pause campaign") {
      updateStatus = {
        where: { id: id },
        data: {
          campaignstatus: "Pause",
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }
    if (newstatus === "remove contact") {
      updateStatus = {
        where: { id: id },
        data: {
          active: 0,
          noop: 0,
          contactstatus: null,
          leads: 0,
          engaged: 0,
          campaignstatus: "Pause",
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }
    if (newstatus === "convert engaged") {
      updateStatus = {
        where: { id: id },
        data: {
          engaged: 1,
          noop: 0,
          contactstatus: null,
          leads: 0,
          campaignstatus: "Pause",
          updatedon: Date(Date.now()),
          updatedby: updatedBy
        }
      };
    }
    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(campaignContactStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully converted", { icon: "success" })
              .then(() => {
                this.props.tableRerender.searchFetch(
                  this.props.limit,
                  this.props.offset
                );
              });
              this.logMaintain(newStatus, id);
            } else swal("Error", { icon: "error" });
          })
          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  convertToClose2 = () => {};

  convertToClose = () => {
    this.setState({ anchorEl: null });
  };
  convertToClose1 = () => {
    this.setState({ anchorE2: null });
  };
  render() {
    const { anchorEl, convertTo } = this.state;
    return (
      <div>
        {localStorage.getItem("role") !== "CUSTOMER" ? (
          <button className="ActionButton" onClick={this.convertToClickList}>
            Action
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              style={{ color: "blue" }}
            >
              <MoreVertIcon />
            </IconButton>
          </button>
        ) : (
          ""
        )}
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.convertToClose}
        >
          <MenuItem
            style={{ color: "#2BADDD" }}
            onClick={this.convertToClose2}
            disabled
          >
            Action
          </MenuItem>
          {this.state.campaignStatus.map((newCamp, key) => {
            return (
              <MenuItem
                key={key}
                onClick={() => {
                  this.onClickToConvertCampaignStatus(
                    newCamp,
                    this.props.campaignStatus
                  );
                }}
              >
                {newCamp}
              </MenuItem>
            );
          })}
          <MenuItem
            onClick={() => {
              this.clickToConvertStatus("NOOP", this.props.contactStatus);
            }}
          >
            No Opp
          </MenuItem>
          <hr />
          <MenuItem
            style={{ color: "#2BADDD" }}
            onClick={this.convertToClose}
            disabled
          >
            Convert to
          </MenuItem>
          {convertTo.map((newstatus, key) => {
            return (
              <MenuItem
                key={key}
                onClick={() =>
                  this.clickToConvertStatus(newstatus, this.props.contactStatus)
                }
                style={{ marginLeft: "10px" }}
              >
                {newstatus}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  }
}

export default ContactDetailsAction;
